var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgE(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 30,
    viewBox: "0 0 94 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 22283",
    d: "M0.908698 1.5145C0.508783 0.847972 0.988896 0 1.76619 0H84.4338C84.7851 0 85.1106 0.184299 85.2913 0.485504L93.3826 13.971C93.7626 14.6044 93.7626 15.3956 93.3826 16.029L85.2913 29.5145C85.1106 29.8157 84.7851 30 84.4338 30H1.76619C0.988896 30 0.508783 29.152 0.908697 28.4855L8.3826 16.029C8.76262 15.3956 8.76262 14.6044 8.3826 13.971L0.908698 1.5145Z",
    fill: "#F99302"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE);
export default __webpack_public_path__ + "static/media/e.296e305b124ea6a31d6265a1444fec2c.svg";
export { ForwardRef as ReactComponent };